        const spaceHolder = document.querySelectorAll('.space-holder');
        const horizontal = document.querySelectorAll('.horizontal');
        const container = document.querySelectorAll('.containerCustom');
        const stickyCustom = document.querySelectorAll('.stickyCustom');

        function calcDynamicHeight(ref) {
            const vw = window.innerWidth;
            const vh = window.innerHeight;
            const objectWidth = ref.scrollWidth;
            return objectWidth - vw + vh;
        }

        container.forEach(function (current, i) {
            spaceHolder[i].style.height = `${calcDynamicHeight(horizontal[i])}px`;
            window.addEventListener('scroll', () => {
                horizontal[i].style.transform = `translateX(-${stickyCustom[i].offsetTop}px)`;
            });
            window.addEventListener('resize', () => {
                spaceHolder[i].style.height = `${calcDynamicHeight(horizontal[i])}px`;
            });
        });
 
        // =======for accordion =======
        let label = document.querySelectorAll(".box");
        let activeIndex;
        label.forEach((e, i) => {e.addEventListener("click", () => {
                removeClass();
                if (!(activeIndex === i)) {e.classList.toggle("active");
                    activeIndex = i;
                } else activeIndex = null;
            })
        })
        function removeClass() {
            label.forEach((e) => {
                e.classList.remove("active");
            })
        }




       